import styled from 'styled-components';
import {Div} from './body';
import PropTypes from 'prop-types';
import {grey} from 'components/primitives/color';


export const CaptionSkeleton = styled(Div)`
    margin-top: 6px;
    margin-bottom: 2px;
    height: 16px;
    width: ${({width}) => width};
    background-color: ${(props) => props.color};
`;
CaptionSkeleton.displayName = 'CaptionSkeleton';

CaptionSkeleton.propTypes = {
    color: PropTypes.string,
    width: PropTypes.string
};

CaptionSkeleton.defaultProps = {
    color: grey.grey700,
    width: '95px'
};

